// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SEO Dash 360 - App Styles */
/* Swiss & High-Contrast Design System */

.App {
  min-height: 100vh;
}

/* Override rounded corners globally for Swiss aesthetic */
* {
  border-radius: 0 !important;
}

/* Chart colors for Recharts */
.recharts-line-curve {
  stroke-width: 2;
}

/* Custom scrollbar for WebKit */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #FAFAFA;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #E5E7EB;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #A1A1AA;
}

/* Animation for score circle */
@keyframes score-fill {
  from {
    stroke-dasharray: 0 251;
  }
}

.score-circle {
  animation: score-fill 1s ease-out forwards;
}

/* Loading spinner */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Fade in animation */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fade-in 0.3s ease-out;
}

/* Progress bar animation */
.progress-animate {
  transition: width 0.5s ease-out;
}

/* Hover lift effect */
.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Focus visible styles */
*:focus-visible {
  outline: 2px solid #002FA7;
  outline-offset: 2px;
}

/* Selection color */
::selection {
  background-color: #002FA7;
  color: white;
}

/* Print styles */
@media print {
  .no-print {
    display: none !important;
  }
  
  body {
    background: white !important;
  }
  
  .bg-[#FAFAFA] {
    background: white !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,wCAAwC;;AAExC;EACE,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* SEO Dash 360 - App Styles */\n/* Swiss & High-Contrast Design System */\n\n.App {\n  min-height: 100vh;\n}\n\n/* Override rounded corners globally for Swiss aesthetic */\n* {\n  border-radius: 0 !important;\n}\n\n/* Chart colors for Recharts */\n.recharts-line-curve {\n  stroke-width: 2;\n}\n\n/* Custom scrollbar for WebKit */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #FAFAFA;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #E5E7EB;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #A1A1AA;\n}\n\n/* Animation for score circle */\n@keyframes score-fill {\n  from {\n    stroke-dasharray: 0 251;\n  }\n}\n\n.score-circle {\n  animation: score-fill 1s ease-out forwards;\n}\n\n/* Loading spinner */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Fade in animation */\n@keyframes fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fade-in 0.3s ease-out;\n}\n\n/* Progress bar animation */\n.progress-animate {\n  transition: width 0.5s ease-out;\n}\n\n/* Hover lift effect */\n.hover-lift {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Focus visible styles */\n*:focus-visible {\n  outline: 2px solid #002FA7;\n  outline-offset: 2px;\n}\n\n/* Selection color */\n::selection {\n  background-color: #002FA7;\n  color: white;\n}\n\n/* Print styles */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  body {\n    background: white !important;\n  }\n  \n  .bg-[#FAFAFA] {\n    background: white !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
